/**
 * Cookie helpers of the SSO handoff (src/utils/auth/ssoHandoff.js): auth.aspx writes its cookies with a
 * UTF-8 Base64 value, the legacy cookieHelper (js/Main.js) with a bare btoa(); both read back here.
 */

export const cookieUtils = {
	/**
	 * Set a cookie with Base64 encoded value
	 * @param {string} name - Cookie name
	 * @param {string} value - Cookie value
	 * @param {number} days - Expiration in days (optional)
	 */
	setEncodedCookie(name, value, days = 7) {
		const encodedValue = btoa(unescape(encodeURIComponent(value)));
		let expires = '';

		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = `; expires=${date.toUTCString()}`;
		}

		document.cookie = `${name}=${encodedValue}${expires}; path=/`;
	},

	/**
	 * Get and decode a cookie value
	 * @param {string} name - Cookie name
	 * @returns {string} - Decoded cookie value
	 */
	getDecodedCookie(name) {
		const nameEQ = `${name}=`;
		const cookies = document.cookie.split(';');

		for (let cookie of cookies) {
			let c = cookie.trim();
			if (c.indexOf(nameEQ) === 0) {
				const encodedValue = c.substring(nameEQ.length);
				try {
					return decodeURIComponent(escape(atob(encodedValue)));
				} catch (e) {
					console.warn(`Failed to decode cookie ${name}:`, e);
					return '';
				}
			}
		}
		return '';
	},

	/**
	 * Delete a cookie, with and without the attributes the legacy cookieHelper writes it with
	 * @param {string} name - Cookie name
	 */
	deleteCookie(name) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=None; Secure`;
	},
};
